import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { transactionsService } from '../services/transactionService'
import { useToast } from '../../view/components/ui/use-toast'
import { useEffect } from 'react'

export const useTransactionId = (id: string) => {
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['transactions', 'transactionById', id],
    queryFn: async () => transactionsService.transactionById(id),
    placeholderData: keepPreviousData,
    enabled: Boolean(id),
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
  }
}
